export default __webpack_public_path__ + "static/media/close.45c05a26.svg";